import { useContext } from 'react';

import { ApplicationContext } from 'providers/AccessManagementApplication';

export function useSelectorApplication() {
  const { state } = useContext(ApplicationContext);

  return {
    applicationsState: state.applications,
    createApplicationState: state.createApplication,
    updateApplicationState: state.updateApplication,
    deleteApplicationState: state.deleteApplication,
    usersByRoleState: state.usersByRole,
    applicationRolesState: state.applicationRoles,
    applicationPermissionsState: state.applicationPermissions,
    selectedApplicationState: state.selectedApplication,
  };
}
